import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useCatalogLanguages } from '../../data/subServicesStore';
import { flagEmoji, langFlagUrl } from '../../utils/langFlags';
import assetUrl from '../../assetUrl';
import './LanguagesSection.css';

// Nom localisé d'une langue du catalogue selon la locale courante
const langName = (lang, locale) =>
  ({ ar: lang.nameAr, en: lang.nameEn }[locale]) || lang.nameFr || lang.code;

export default function LanguagesSection() {
  const { t, lang } = useLanguage();
  const l = t.homeLanguages;
  const { languages: catalogLangs } = useCatalogLanguages();

  // 5 premières langues actives du catalogue MongoDB — repli i18n hors-ligne
  const featured = catalogLangs.length
    ? catalogLangs.slice(0, 5).map((cl) => ({
      key: cl.id || cl.code,
      name: langName(cl, lang),
      flagUrl: langFlagUrl(cl),
      emoji: flagEmoji(cl.flag),
    }))
    : (l.featured || []).map((f) => ({
      key: f.name,
      name: f.name,
      flagUrl: assetUrl(`/images/flags/${f.code}.svg`),
      emoji: '',
    }));

  return (
    <section className="section home-languages" id="home-languages">
      <div className="container">
        <header className="home-languages-head">
          <h2>{l.title}</h2>
          <p>{l.intro}</p>
        </header>

        <ul className="home-languages-grid">
          {featured.map((language, i) => (
            <li key={language.key} className="home-language-card" style={{ '--hl-i': i }}>
              {language.flagUrl ? (
                <img
                  className="home-language-flag"
                  src={language.flagUrl}
                  alt=""
                  loading="lazy"
                  decoding="async"
                />
              ) : (
                <span className="home-language-flag home-language-flag--emoji" aria-hidden="true">
                  {language.emoji || '🌐'}
                </span>
              )}
              <span className="home-language-name">{language.name}</span>
            </li>
          ))}
        </ul>

        <div className="home-languages-cta">
          <Link to="/languages" className="btn btn-outline">
            {l.moreLanguages}
            <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}
